import { hasCampaignTemplateInstance } from "containers/admin/clients/campaign/campaign-template-instance.utils";
import { useTouchpoint } from "hooks/api/use-touchpoints";
import { useEmailWriterPollingSessionActive } from "hooks/use-email-writer-polling-session-active";
import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";
import { useCurrentTouchpoint } from "hooks/api/use-current-touchpoint";
import { isEmailWriterJobRunning } from "utilities/email-writer-completion";
import { TouchpointDTOBatchJobExecutionStatus } from "generated/schemas";

const EMAIL_WRITER_POLL_INTERVAL_MS = 3000;

export const useIsEmailWriterGenerating = () => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const currentTouchpoint = useCurrentTouchpoint();
  const isTemplateCampaign = hasCampaignTemplateInstance(currentCampaign);
  const isEmailWriterSessionActive = useEmailWriterPollingSessionActive(
    currentCampaign.id,
    currentClient.id,
  );
  const isEmailWriterContext = isTemplateCampaign || isEmailWriterSessionActive;

  // Completion poller owns refetch during an email-writer session (detail for rewrite,
  // list for create-with-writer). Avoid a second detail poll loop here.
  const { data: touchpointData } = useTouchpoint(currentTouchpoint.id, {
    refetchInterval: (query) =>
      !isEmailWriterSessionActive &&
      isEmailWriterContext &&
      query.state.data?.batchJobExecutionStatus === TouchpointDTOBatchJobExecutionStatus.RUNNING
        ? EMAIL_WRITER_POLL_INTERVAL_MS
        : false,
  });

  const batchJobExecutionStatus =
    touchpointData?.batchJobExecutionStatus ?? currentTouchpoint.batchJobExecutionStatus;

  return isEmailWriterJobRunning({
    isTemplateCampaign: isEmailWriterContext,
    touchpointType: currentTouchpoint.type,
    batchJobExecutionStatus,
  });
};
